import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import React from "react";

interface RecordLinkProps {
  readonly description: string;
  readonly label: string;
  readonly onClick: () => void;
}

export const RecordLink: FC<RecordLinkProps> = ({
  description,
  label,
  onClick,
}) => (
  <button
    className={`
      flex w-full items-center justify-between rounded-md border p-3 text-left
      hover:bg-muted
    `}
    onClick={onClick}
    type="button"
  >
    <div className="flex flex-col">
      <span className="font-medium">{label}</span>
      <span className="text-sm text-muted-foreground">{description}</span>
    </div>
    <ChevronRight className="size-4 text-muted-foreground" />
  </button>
);
